import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';
import classNames from 'classnames';

export type TBlockTitleProps = TParentComponentProps & {};

export const BlockTitle: FunctionComponent<TBlockTitleProps> = ({
  className,
  ...otherProps
}) => {
  const cx = classNames({
    [className]: !!className,
  });

  return <ParentComponent className={cx} {...otherProps} />;
};

BlockTitle.defaultProps = {
  as: 'aside',
  defaultClassName: 'shop-layout__sidebar',
};

export default BlockTitle;
